<template>
  <div class="cxampleWrap" id="partner">
    <div class="middle">
      <dl class="cxample">
        <dt>合作伙伴</dt>
        <dd>
          <img src="@/assets/bank/bank_01.png" />
          <img src="@/assets/bank/bank_02.png" />
          <img src="@/assets/bank/bank_03.png" />
          <img src="@/assets/bank/bank_04.png" />
          <img src="@/assets/bank/bank_05.png" />
          <img src="@/assets/bank/bank_06.png" />
          <img src="@/assets/bank/bank_07.png" />
          <img src="@/assets/bank/bank_08.png" />
          <img src="@/assets/bank/bank_09.png" />
          <img src="@/assets/bank/bank_10.png" />
          <img src="@/assets/bank/bank_11.png" />
          <img src="@/assets/bank/bank_12.png" />
          <img src="@/assets/bank/bank_13.png" />
          <img src="@/assets/bank/bank_14.png" />
          <img src="@/assets/bank/bank_15.png" />
          <img src="@/assets/bank/bank_16.png" />
          <!--<img src="@/assets/bank/bank_17.png" />-->
          <img src="@/assets/bank/bank_18.png" />
          <img src="@/assets/bank/bank_19.png" />
          <img src="@/assets/bank/bank_20.png" />
          <img src="@/assets/bank/bank_21.png" />
          <img src="@/assets/bank/bank_22.png" />
          <img src="@/assets/bank/bank_23.png" />
          <img src="@/assets/bank/bank_24.png" />
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'partner'
}
</script>
<style lang="less" scoped>

.cxampleWrap {
  padding: 10px 0;
  background-color: #fff;
  padding-bottom: 30px;
  .cxample {
    dt {
      color: #202122;
      font-family: PingFang SC;
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      padding: 15px 0;
      text-align: center;
    }
    dd {
      margin: 0;
      display: flex;
      // overflow: hidden;
      flex-wrap: wrap;
      justify-content: flex-start;
      img:nth-of-type(6n) {
        margin-right: 0;
      }
      img {
        display: block;
        width: 202px;
        height: 82px;
        margin: 9px 0;
        margin-right: 17px;
        &:hover {
          transform: scale(1.1);
        }

      }
    }
  }
 }
</style>
